<template>
  <LayoutContent>
    <app-page-title :title="$t('label.topPick')"></app-page-title>
    <v-card class="my-6 rounded-lg">
      <v-img :src="topPickBanner" max-height="400"></v-img>
    </v-card>
    <div>
      <v-row>
        <v-col v-for="product in topPickProduct" :key="product.id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
          <item :productInfo="product"></item>
        </v-col>
      </v-row>
    </div>
  </LayoutContent>
</template>

<script>
import { mapGetters } from 'vuex'
import { ProductDealType } from '@/constants/enums'
import Item from '@/components/product/Item.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
import { PRODUCT_PRODUCTS_BY_DEAL_TYPE } from '@/store/product.module'

export default {
  name: 'BestSeller',
  components: {
    Item,
    LayoutContent
  },
  created() {
    console.log('best seller')
    this.getTopPickproduct()
  },
  computed: {
    ...mapGetters('page', ['bestSellers']),
    topPickImageId() {
      return this.$route.params.topPickImageId
    },
    topPickProduct() {
      return this.$store.state.product.topPickProduct
    },
    topPickBanner() {
      return this.bestSellers.filter((item) => {
        return item.slider_image_id == this.topPickImageId
      })[0].image_desktop
    }
  },
  methods: {
    getTopPickproduct() {
      let obj = {
        productDealType: ProductDealType.TOP_PICKS,
        productTopPickImageId: this.topPickImageId
      }
      this.$store.dispatch(`${PRODUCT_PRODUCTS_BY_DEAL_TYPE}`, { obj })
    }
  }
}
</script>
